<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-07-03 20:00:12
 * @LastEditors: 侯鹏许(houpengxu@qq.com)
 * @LastEditTime: 2020-03-09 16:56:30
 * @Description: file content
 -->

<template>
  <div class="container" style="padding-bottom:50px;">
    <router-view></router-view>
    <Tabbar3 v-if="isShowGuide"></Tabbar3>
    <SelfAction v-if="isShowGuide&&selfAction.isShow" :options="selfAction.options"></SelfAction>
    <ShareAfterAction
      v-if="isShowGuide&&shareAfterAction.isShow"
      v-on:close="shareAfterAction.isShow=false"
    ></ShareAfterAction>
    <CreateAfterGuide
      v-if="isShowGuide&&isShowCreateAfterGuide"
      v-on:close="isShowCreateAfterGuide=false"
    ></CreateAfterGuide>
  </div>
</template>

<script>
import util from "@/utils/utils";
import wxsdk from "@/utils/wxsdk";
import Cookies from "js-cookie";
import * as comreq from "@/utils/comreq";
import { mapState, mapMutations } from "vuex";
const Tabbar3 = () => import("@/components/tabbar3");
const SelfAction = () => import("@/components/self-action");
const ShareAfterAction = () => import("@/components/share-after-action");
const CreateAfterGuide = () => import("@/components/create-after-guide");
export default {
  components: {
    Tabbar3,
    SelfAction,
    ShareAfterAction,
    CreateAfterGuide
  },
  props: {},
  data() {
    return {
      selfAction: {
        triggerTime: 20, //等待时间秒
        passedTime: 0, //秒
        isShow: false, //是否显示
        options: {}, //自行动组件参数
        isPopEveryTime: false, //每次都弹框，不进行缩小
        isBallEveryTime: false //每次都缩小，不进行缩小，优先级高于上面一条
      },
      shareAfterAction: {
        isShow: false
      },
      isShowCreateAfterGuide: false
    };
  },
  watch: {},
  computed: {
    ...mapState([
      "isShowGuide",
      "isInMiniProgram",
      "receiveSpreadInfo",
      "shareSpreadInfo",
      "pageInfo",
      "cardInfo",
      "userInfo",
      "hdkUserInfo"
    ])
  },
  methods: {
    ...mapMutations({
      SET_PAGEINFO: "SET_PAGEINFO",
    }),
    // 设置内容自行动
    setSelfAction: function() {
      let that = this;
      comreq.checkPageSelfByHDK(that.pageInfo.PageId).then(function(data) {
        // 设置了自行动，开启定时器
        if (data) {
          var zxdObj = Cookies.get("t3_20190612_self_" + that.pageInfo.PageId);
          if (zxdObj) {
            that.showSelfAction(1);
          } else {
            var tmpInterval = setInterval(function() {
              that.selfAction.passedTime++;
              if (that.selfAction.triggerTime == that.selfAction.passedTime) {
                that.showSelfAction(0);
                let inFifteenMinutes = new Date(
                  new Date().getTime() + 365 * 24 * 60 * 60 * 1000
                );
                Cookies.set("t3_20190612_self_" + that.pageInfo.PageId, 1, {
                  expires: inFifteenMinutes
                });
                clearInterval(tmpInterval);
              }
            }, 1000);
          }
        }
      });
    },
    showSelfAction: function(type) {
      this.selfAction.options = {
        refereeopenid: this.$refereeopenid,
        openid: this.$openid,
        passport: this.$passport,
        apiurl: this.global.API_URL,
        pageid: this.pageInfo.PageId,
        type: type,
        wxType: 1 //小程序的微信号
      };
      if (this.selfAction.isPopEveryTime) {
        this.selfAction.options.type = 0;
      }
      if (this.selfAction.isBallEveryTime) {
        this.selfAction.options.type = 1;
      }
      this.selfAction.isShow = true;
    },
    // 发送浏览时长
    sendTime(guid) {
      let that = this;
      let postObj = {
        openid: this.$openid,
        pageid: this.$pageid,
        tempid: guid,
        channelid: "",
        refereeopenid: this.$refereeopenid,
        projectid: this.pageInfo.Pid,
        psn: this.$psn
      };
      comreq.actIp(this, postObj);
    },
    // 开始统计浏览时长
    setSendTime() {
      let that = this;
      let guid = util.getGuid();
      setTimeout(function() {
        that.sendTime(guid);
        setInterval(function() {
          that.sendTime(guid);
        }, 3000);
      }, 1000);
    }
  },
  created() {
    const that = this;
    // if (
    //   util.queryCheck(
    //     {
    //       rscuid: "如是用户openid"
    //     },
    //     that.$route.query
    //   )
    // ) {

    // }
    util.checkMapStateCallback(that, ["cardInfo"]).then(() => {
      // 获取页面信息
      comreq
        .cardPageInfo(that.cardInfo.AppGzh.GzhAppid, that.$rscuid)
        .then(function(pageInfo) {
          that.SET_PAGEINFO(pageInfo);
          util
            .getIsInMiniProgram(that.isInMiniProgram)
            .then(function(isMiniProgram) {
              if (isMiniProgram) {
                // 小程序webview
                util.setVcardShare(that, that.shareSpreadInfo, true);
              } else {
                // 微信网页
                // 需要设置分享
                util.setVcardShare(that, that.shareSpreadInfo);
                that.global.SHARE_CALLBACK_OK = function() {
                  comreq.actShare(that);
                  if (
                    that.hdkUserInfo &&
                    that.hdkUserInfo.User &&
                    that.cardInfo &&
                    that.cardInfo.User &&
                    that.hdkUserInfo.User.Id == that.cardInfo.User.Id
                  ) {
                    //不展示分享后页面
                  } else {
                    that.shareAfterAction.isShow = true;
                  }
                };
              }
            });
        });
    });
    // 设置内容自行动
    util.checkMapStateCallback(that, ["pageInfo"]).then(() => {
      // that.setSelfAction();
      that.setSendTime();
      // 上报设备信息
      comreq.actMt(that);
    });
  },
  mounted() {}
};
</script>
<style lang="css" scoped>
.container {
}
</style>